import React from "react";
import { ShieldCheckIcon } from "lucide-react";
export function GuaranteeSection() {
  return <section className="bg-ivory" data-id="element-112" data-mp="4uqfz2u0sewh">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center md:py-24" data-id="element-113" data-mp="4vrz7ul6w7pa">
        <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-leaf-light ring-[5px] ring-leaf/30" data-id="element-114" data-mp="9tbemxtmiqit">
          <ShieldCheckIcon className="h-10 w-10 text-leaf-deep" aria-hidden="true" data-id="element-115" data-mp="euqzaorw2v0o" />
        </span>
        <h2 className="mt-6 font-display text-[1.85rem] font-bold leading-tight text-royal md:text-[2.4rem]" data-id="element-116" data-mp="jsadxpsi19t5">
          Essayez votre Méga Pack en toute sérénité
        </h2>
        <p className="mx-auto mt-4 w-fit rounded-full bg-leaf px-5 pb-1.5 pt-2 font-display text-sm font-extrabold tracking-wide text-white md:text-base" data-id="element-117" data-mp="slvv1fs4z35q">
          GARANTIE SATISFAIT OU REMBOURSÉ — 7 JOURS
        </p>
        <p className="mt-6 leading-relaxed text-cocoa md:text-lg" data-id="element-118" data-mp="12kl8mwd021g6">
          Nous souhaitons que ce Méga Pack soit une belle ressource pour votre famille. Si le
          contenu ne répond pas à vos attentes, vous pouvez nous contacter dans les 7 jours
          suivant votre achat pour demander un remboursement, conformément aux conditions de
          garantie.
        </p>
      </div>
    </section>;
}